function normalizeCategory (category) {
  if (category === null || typeof category !== 'object' || Array.isArray(category)) {
    return null
  }

  const uid = Number(category.uid)
  if (!Number.isInteger(uid) || uid <= 0) {
    return null
  }

  return { ...category, uid }
}

function parseAllowedCategories (value) {
  try {
    const parsed = JSON.parse(value)
    const categories = Array.isArray(parsed)
      ? parsed
      : parsed !== null && typeof parsed === 'object'
        ? Object.values(parsed)
        : []

    return categories
      .map(normalizeCategory)
      .filter(category => category !== null)
  } catch (error) {
    return []
  }
}

function parsePositiveInteger (value, fallback) {
  const parsed = Number(value)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback
}

function buildCategoryFilter (entriesFilter, categories) {
  const selectedUid = parsePositiveInteger(entriesFilter, 0)
  const categoryUids = categories.map(category => category.uid).join(',')

  if (selectedUid > 0 && categoryUids) {
    return `${selectedUid};${categoryUids}`
  }

  return selectedUid > 0 ? String(selectedUid) : categoryUids
}

module.exports = {
  buildCategoryFilter,
  parseAllowedCategories,
  parsePositiveInteger
}
